import styled from '@emotion/styled'

const HeaderContainer = styled.div`
    position: sticky;
    top: 0;
    z-index: 99;

    @media (max-width: ${props => props.theme.bps.md}) {
        position: inherit;
    }
`

const NavControlPanelHeader = styled.header`
    position: sticky;
    z-index: 99;
    min-height: 4.5rem;
    padding: 0 1.5rem;
    display: flex;
    align-items: center;

    background-color: rgba(0, 0, 0, 0.1);

    @media (max-width: ${props => props.theme.bps.md}) {
        padding: 0 1rem;
    }
`

export { HeaderContainer, NavControlPanelHeader }
